import {configureStore} from '@reduxjs/toolkit';
import exampleReducer from './exampleState';
import userReducer from './user';
import xkwReducer from './xueke';

const store = configureStore({
  reducer: {
    example: exampleReducer,
    xkw: xkwReducer,
    user: userReducer,
  },
});

// 从 store 本身推断 `RootState` 和 `AppDispatch` 类型
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
